<template>
  <div v-if="show" :id="id" :aria-labelledby="`${id}-tab`" class="p-2 rounded-lg" role="tabpanel">
    <slot v-if="isLazyLoad === false || (isLazyLoad && lazyShow)"></slot>
  </div>
</template>

<script>
import EventBus from "@/helpers/EventBus";

export default {
  name: "TabContent",
  props: {
    id: {
      type: String,
      required: true,
    },
    show: {
      type: Boolean,
      default: true
    },
  },
  computed: {},
  data: () => ({
    lazyShow: false,
    isLazyLoad: null,
    tabsId: "undefined"
  }),
  methods: {
    onShowTab(tabId) {
      if (tabId === `#${ this.id }`) {
        this.lazyShow = true;
      }
    }
  },
  mounted() {
    try {
      const tabPanel = document.querySelector(`#${ this.id }`).parentNode.parentNode.querySelector(".tabs-panel");
      this.isLazyLoad = tabPanel.getAttribute("lazy-load") || false;
      this.tabsId = tabPanel.getAttribute("id") || "undefined";

      this.isLazyLoad && EventBus.$on(`${ this.tabsId }-onShowTab`, this.onShowTab);
    } catch (e) {
      //
    }

  },
  beforeDestroy() {
    EventBus.$off(`${ this.tabsId }-onShowTab`);
  }
}
</script>

